/**
 * @module project/components/participate_form/intro_step
 */
import React, { PropTypes, Component } from 'react';
import ParticipateButtons from 'project/containers/participate_buttons';
import ProjectLink from 'common/containers/project_link';
import { Link } from 'react-router';

/**
 * Participate upload form step that shows participation requirements
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class ParticipateIntroStep extends Component {
  constructor(props) {
    super(props);
    this.state = { agreed: props.agreed };

    this.agreeRequirements = this.agreeRequirements.bind(this);
  }

  agreeRequirements() {
    this.setState({ agreed: !this.state.agreed });
  }

  getSubcatRequirements() {
    const { entryType, project } = this.props;

    if (entryType !== "image") {
      return null;
    }

    /* "Book & Magazine" category projects */
    if ([3, 25].includes(project.category)) {
      return (
        <p>
          Everything in my entry (except for the stock art image, if present) is my original work.<br />
          I have full rights to sell everything in my entry (including any stock images).
        </p>
      );
    }

    return (
      <p>
        I did not use {' '}
        <Link target="_blank" to="/help/rules-code-of-conduct-creatives/overused-overdone-logo-concepts/">
        stock art, clip art, or overused logo concepts</Link>.<br />
        I understand that if I use stock art, my account will be immediately and permanently
        removed.
      </p>
    );
  }

  render() {
    const { project } = this.props;

    return (
      <div className="participate-step intro-step">
        <div className="modal-header">
          <h5>Before you submit...</h5>
        </div>
        <div className="modal-content">
          <h2>Participation Requirements</h2>
          <div className="participate-content">
            <p>
              I have read the client&apos;s&nbsp;
              <ProjectLink target="_blank" project={project} linkTitle="brief" /> and my entry matches
              the brief requirements.
            </p>
            <p>
              I have read and agree to the crowdspring {' '}
              <Link target="_blank" to="/standards-of-conduct-creative">standards of conduct</Link>.
            </p>
            { this.getSubcatRequirements() }
            <fieldset>
              <div className="checkbox">
                <input
                  id="agree_requirements"
                  type="checkbox"
                  className="form-control"
                  checked={!!this.state.agreed}
                  onChange={this.agreeRequirements}
                />
                <label htmlFor="agree_requirements" className="form-label">
                  I have read and understand the above requirements.
                </label>
              </div>
            </fieldset>
          </div>
          <div className="modal-actions right">
            <ParticipateButtons
              nextActive={this.state.agreed}
              onToggleForm={this.props.onCloseForm}
            />
          </div>
        </div>
      </div>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {bool} agreed - controls if user agrees to terms
 * @property {string} projectSlug - current projcet slug
 * @property {func} onCloseForm - function called when close form button is clicked
 * @property {string} entryType - entry type for this project
 */
ParticipateIntroStep.propTypes = {
  agreed: PropTypes.bool,
  onCloseForm: PropTypes.func,
  entryType: PropTypes.string,
  project: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./project/components/participate_form/intro_step.jsx